import React from 'react';

const WhyChooseUs = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Why Choose FIC College?</h2>
      
      <div className="prose max-w-none">
        <p className="text-gray-600 mb-6">
          At FIC College, we're committed to providing an exceptional educational experience that prepares you for success in your chosen field.
        </p>
        
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          <div className="bg-blue-50 p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Academic Excellence</h3>
            <p className="text-gray-600">
              Our programs are designed with input from industry leaders to ensure you gain the knowledge and skills that employers value most.
            </p>
          </div>
          
          <div className="bg-blue-50 p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Experienced Faculty</h3>
            <p className="text-gray-600">
              Learn from professors who are experts in their fields and passionate about teaching and mentoring students.
            </p>
          </div>
          
          <div className="bg-blue-50 p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Modern Facilities</h3>
            <p className="text-gray-600">
              Study in state-of-the-art facilities equipped with the latest technology and resources to support your learning.
            </p>
          </div>
          
          <div className="bg-blue-50 p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-black mb-3">Career Support</h3>
            <p className="text-black">
              Benefit from our career services, including internship opportunities, job placement assistance, and career counseling.
            </p>
          </div>
        </div>
        
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-black">
                Ready to start your journey? <a href="/apply-form" className="bg-maroon-500 hover:bg-maroon-700 text-white font-medium py-2 px-4 rounded">Apply now</a> or <a href="/contact" className="bg-maroon-500 hover:bg-maroon-700 text-white font-medium py-2 px-4 rounded">contact our admissions team</a> for more information.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
